import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import { websiteDevelopmentModasaConfig } from './servicePageConfigs';

const ServicewebModasa = () => <ServicePageTemplate {...websiteDevelopmentModasaConfig} />;

export default ServicewebModasa;
